import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { STATES } from '@/constants/patient';
import IconLoading from '@/components/icon/IconLoading.vue';
const STATE_NAME_MAP = Object.fromEntries(STATES.map(s => [s.code, s.statename.toLowerCase()]));
const STATE_DISPLAY_NAME_MAP = Object.fromEntries(STATES.map(s => [s.code, s.statename]));
export default {
  components: {
    IconLoading
  },
  props: {
    sourceDoctor: {
      type: Object,
      default: null
    },
    panelSummary: {
      type: Object,
      default: null
    },
    loadingSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: '',
      selectedStates: []
    };
  },
  computed: {
    licensedAbbrs() {
      var _this$panelSummary, _this$panelSummary$so;
      return ((_this$panelSummary = this.panelSummary) === null || _this$panelSummary === void 0 ? void 0 : (_this$panelSummary$so = _this$panelSummary.source) === null || _this$panelSummary$so === void 0 ? void 0 : _this$panelSummary$so.licensedStates) || [];
    },
    allStates() {
      var _this$panelSummary2;
      const pools = ((_this$panelSummary2 = this.panelSummary) === null || _this$panelSummary2 === void 0 ? void 0 : _this$panelSummary2.statePool) || [];
      const poolMap = new Map(pools.map(p => [p.state, p]));
      const licensedSet = new Set(this.licensedAbbrs);
      const unlicensedWithPatients = pools.filter(p => !licensedSet.has(p.state) && Number(p.total || 0) > 0).map(p => p.state);
      return [...this.licensedAbbrs, ...unlicensedWithPatients].map(abbr => {
        const pool = poolMap.get(abbr);
        return {
          abbr,
          name: STATE_DISPLAY_NAME_MAP[abbr] || abbr,
          licensed: licensedSet.has(abbr),
          total: Number((pool === null || pool === void 0 ? void 0 : pool.total) || 0),
          active: Number((pool === null || pool === void 0 ? void 0 : pool.active) || 0),
          cancelled: Number((pool === null || pool === void 0 ? void 0 : pool.cancelled) || 0),
          owned: Number((pool === null || pool === void 0 ? void 0 : pool.owned) || 0),
          covering: Number((pool === null || pool === void 0 ? void 0 : pool.covering) || 0)
        };
      }).sort((a, b) => a.abbr.localeCompare(b.abbr));
    },
    filteredStates() {
      const term = this.search.trim().toLowerCase();
      if (!term) {
        return this.allStates;
      }
      return this.allStates.filter(s => {
        return s.abbr.toLowerCase().includes(term) || (STATE_NAME_MAP[s.abbr] || '').includes(term);
      });
    },
    selectableStates() {
      return this.allStates.filter(s => s.total > 0);
    },
    allSelected() {
      if (!this.selectableStates.length) {
        return false;
      }
      return this.selectableStates.every(s => this.selectedStates.includes(s.abbr));
    },
    selectedCounterLabel() {
      const total = this.allStates.length;
      if (total > 0 && this.selectedStates.length === total) {
        return `All ${total}`;
      }
      return `${this.selectedStates.length} of ${total}`;
    }
  },
  watch: {
    sourceDoctor() {
      this.search = '';
      this.selectedStates = [];
    },
    panelSummary(summary) {
      this.selectedStates = summary ? this.selectableStates.map(s => s.abbr) : [];
    },
    selectedStates(val) {
      this.$emit('change', {
        states: val,
        stateCounts: this.allStates
      });
    }
  },
  methods: {
    onToggleAll(value) {
      this.selectedStates = value ? this.selectableStates.map(s => s.abbr) : [];
    }
  }
};